import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VoucherService {

  private _voucherapiUrl = `${environment.travel}/vouchers`
  private _inventoryapiUrl = `${environment.inventory}`
  private _travelapiUrl = `${environment.travel}`

  constructor(
    private _http: HttpClient
  ) { }

  addVoucher(formData:any):Observable<any>{
    return this._http.post<any>(`${this._voucherapiUrl}/addvoucher`, formData);
  }

  getAllVouchers(pageNumber:any,pageSize:any, token:any, searchValue:any, filters: any):Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20,
      search: searchValue,
      filters: filters
    }
    return this._http.post<any>(`${this._voucherapiUrl}`,paginationSettings)
  }
  
  getAllVouchersForLead(leadId:any,pageNumber:any,pageSize:any, token:any):Observable<any>{
    const paginationSettings = {
      pageNumber: pageNumber || 1,
      pageSize: pageSize || 20
    }
    return this._http.post<any>(`${this._voucherapiUrl}/${leadId}`,paginationSettings)
  }

  getVoucher(voucherId:any):Observable<any>{
    return this._http.get<any>(`${this._voucherapiUrl}/voucher/${voucherId}`);
  }

  getVoucherAsTemplateHtml(voucherId:any):Observable<any>{
    return this._http.get<any>(`${this._inventoryapiUrl}/vouchertemplate/${voucherId}`, { responseType: 'text' as 'json' })
  }

  getIndividualVoucherAsTemplateHtml(voucherId:any, req: any):Observable<any>{
    return this._http.post<any>(`${this._inventoryapiUrl}/individualvouchertemplate/${voucherId}`, req, { responseType: 'text' as 'json' })
  }

  deleteVoucher(voucherId:any):Observable<any>{
    return this._http.delete<any>(`${this._voucherapiUrl}/voucher/${voucherId}`);
  }

  updateVoucher(voucherId:any, formData:any):Observable<any>{
    return this._http.put<any>(`${this._voucherapiUrl}/voucher/${voucherId}`, formData);
  }

  performBulkActions(req:any): Observable<any>{
    return this._http.put<any>(`${this._travelapiUrl}/updatevouchers`, req)
  }


}
